import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

const DEFAULT_COLS = 12;

export const cockpitStatisticsWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitStatisticsAdViews',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_statistic_ad_views_widget_title',
      text: 'cockpit_statistic_ad_views_widget_text',
      linksTitle: 'cockpit_statistic_ad_views_widget_link_title',
      infoText: 'cockpit_statistic_ad_views_widget_info_text',
    },
  },
  {
    name: 'cockpitStatisticsDigitalTourViews',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_statistic_digital_tour_widget_title',
      text: 'cockpit_statistic_digital_tour_widget_text',
      linksTitle: 'cockpit_statistic_digital_tour_widget_link_title',
      infoText: 'cockpit_statistic_digital_tour_widget_info_text',
    },
  },
  {
    name: 'cockpitStatisticsExposeDownloadsViews',
    cols: DEFAULT_COLS,
    props: {
      title: 'cockpit_statistic_expose_downloads_widget_title',
      text: 'cockpit_statistic_expose_downloads_widget_text',
      linksTitle: 'cockpit_statistic_expose_downloads_widget_link_title',
      infoText: 'cockpit_statistic_expose_downloads_widget_info_text',
      interestLink: true,
    },
  },
]);
